import { createFileRoute } from '@tanstack/react-router'

import { listCompaniesOptions } from '@/api/codegen/@tanstack/react-query.gen'

export const Route = createFileRoute('/_auth/$companyId/spaces')({
  beforeLoad: () => {
    // TODO: we should check if the user has access to the spaces
  },
  loader: async ({ params, context: { queryClient } }) => {
    const companies = await queryClient.ensureQueryData(
      listCompaniesOptions({}),
    )
    const company = companies.items?.find(({ id }) => id === params.companyId)

    return {
      breadcrumbTitle: company?.name || '',
      breadcrumbPath: '/$companyId/spaces',
    }
  },
})
